<template>
  <div class="wrap">
    <div class="wrap-header">
      <el-button @click="goBack" class="go-back">返回</el-button>
      <span class="cdn-logo">XPSCDN|兴盛优选</span>
      <div class="search">
        <h1 style="font-size: 30px;">{{params.projectName}}</h1>
        <h4 style="color: #777">{{params.projectDescript}}</h4>
      </div>
    </div>
    <div class="wrap-body">
      <el-timeline class="timeline">
        <el-timeline-item v-for="(activity, i) in activities" :key="i" :timestamp="activity.versionName" placement="top" color="#5862ab" size="large">
          <div class="links" v-for="(link, index) in activity.links" :key="index">
            <div class="link">
              <div>{{link.linkCdnAddress}}</div>
              <span style="font-size:12px;color:#ccc">{{link.linkDescript}}</span>
            </div>
            <div class="copy">
              <el-button :disabled="link.ext!=='js'" type="" plain :id="`script-${i}-${index}`" @click="handleCopy(link.linkCdnAddress, 1,{i,index})" data-clipboard-action="copy">复制script</el-button>
              <el-button type="primary" plain :id="`link-${i}-${index}`" @click="handleCopy(link.linkCdnAddress, 2,{i,index})" data-clipboard-action="copy">复制链接</el-button>
              <el-button type="danger" plain @click="handleDelete(link.id)">删除CDN</el-button>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { cdnsApi } from '@/api/index';
import { getExt } from '@/common/utils/ext.js';
import { showLoading, hideLoading } from '@/plugins/loading';
export default {
  data () {
    return {
      params: {},
      forwardText: '',
      activities: []
    }
  },
  mounted () {
    this.params = this.$route.query;
    this.getLinks();
  },
  methods: {
    async getLinks () {
      showLoading();
      const { data } = await cdnsApi.getLinkList({
        projectId: this.params.id
      })
      if (data) {
        data.forEach(item => {
          if (item.links && item.links.length > 0) {
            item.links.forEach(link => {
              link.ext = getExt(link.linkCdnAddress)
            })
          }
        })
        this.activities = data;
      }
      hideLoading();
    },
    goBack () {
      this.$router.push({ path: '/xpsCdn' });
    },
    handleCopy (link, num, data) {
      const { i, index } = data;
      let clipboard = null;
      if (num == 1) {
        clipboard = new Clipboard(`#script-${i}-${index}`, {
          text: function () {
            return `<script type="text\/javascript" src="${link.toString()}"><\/script>`;
          }
        })
      } else {
        clipboard = new Clipboard(`#link-${i}-${index}`, {
          text: function () {
            return link.toString();
          }
        })
      }
      clipboard.on('success', (e) => {
        this.$message.success("复制成功！")
        e.clearSelection();
        clipboard.destroy();
      })
      clipboard.on('error', (e) => {
        this.$message.error("复制失败，请重试！")
        e.clearSelection();
        clipboard.destroy();
      })

    },
    // 删除CDN
    handleDelete (id) {
      this.$confirm('您确定要删除该CDN资源吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await cdnsApi.deleteLink({ id })
        if (res.code === 200) {
          this.getLinks();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-timeline-item__timestamp {
  color: #5862ab;
  line-height: 1;
  font-size: 18px;
}
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrap-header {
    height: 260px;
    background-color: #ecf5ff;
    width: 100%;
    position: relative;
    .go-back {
      margin: 30px;
      margin-left: 100px;
      font-size: 14px;
      padding: 7px;
      color: #5862ab;
      background-color: rgba(0, 0, 0, 0);
    }
    .cdn-logo {
      display: block;
      color: #5862ab;
      line-height: 30px;
      font-size: 24px;
      position: absolute;
      top: 40px;
      right: 100px;
    }
    .search {
      width: 40%;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      color: #5862ab;
      transform: translate(-50%, -50%);
      .cdn-input {
        outline: none;
      }
      .icon {
        position: absolute;
        top: 4px;
        right: 4px;
        font-size: 24px;
        color: #ccc;
        cursor: pointer;
      }
    }
    .upload {
      color: white;
      font-size: 16px;
      position: absolute;
      top: 40px;
      right: 70px;
    }
  }
  .wrap-body {
    flex: 1;
    width: 100%;
    background-color: #fff;
    overflow: auto;
    .timeline {
      margin: 0 auto;
      width: 1150px;
      padding: 20px;
      .links {
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 50px;
        .link {
          width: 450px;
        }
        .copy {
          width: 300px;
          span {
            display: inline-block;
            margin-left: 10px;
            padding: 3px;
            border: 1px solid #ccc;
          }
        }
      }
    }
  }
}

::v-deep .el-timeline-item__timestamp {
  color: #5862ab;
  font-size: 26px;
}
</style>